import * as React from 'react';

type Props = {
    content: React.ReactNode;
};

export function DashboardCardSideContent(props: Props) {
    return <div className='flex width-fit-content full-height border-left'>{props.content}</div>;
}
